import { Fragment } from 'react';
import { twMerge } from 'tailwind-merge';

import { Progress } from '@/components/ui/daisy';
import { Colors } from '@/components/ui/types';
import { gradeColor } from '@/utils/shared/gradeColor';
import percentage from '@/utils/statistics/percentage';

const textColorClasses: Record<Colors, string> = {
  default: '',
  neutral: 'text-neutral',
  primary: 'text-primary',
  secondary: 'text-secondary',
  accent: 'text-accent',
  info: 'text-info',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-error',
};

type CourseProgressIndicatorProps = {
  progress: number;
  progressClassName?: string;
};

export default function CourseProgressIndicator({
  progress,
  progressClassName,
}: CourseProgressIndicatorProps) {
  const progressPercentage = percentage(progress, 2);
  const color = gradeColor(progressPercentage, 100);

  return (
    <Fragment>
      <Progress
        color={color}
        value={progressPercentage}
        className={twMerge('h-2', progressClassName)}
      />
      <span
        className={twMerge('text-xs font-semibold', textColorClasses[color])}
      >
        {progressPercentage}%
      </span>
    </Fragment>
  );
}
